import { render, staticRenderFns } from "./gridReportFornitori.vue?vue&type=template&id=1d20d7ff&"
import script from "./gridReportFornitori.vue.ts?vue&type=script&lang=ts&"
export * from "./gridReportFornitori.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports